import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Smartphone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { postToApp } from "@/lib/appMode";

export default function AppModeBlocked() {
  const { pathname } = useLocation();
  useEffect(() => { postToApp({ type: "blocked_navigation", path: pathname }); }, [pathname]);
  return (
    <div className="min-h-screen bg-[#08080c] flex items-center justify-center p-6" data-testid="app-mode-blocked">
      <div className="max-w-sm text-center space-y-4">
        <Smartphone className="w-10 h-10 text-purple-300 mx-auto" />
        <h1 className="text-2xl font-black text-white">Open this on rgmstudio.org</h1>
        <p className="text-sm text-gray-400">
          This page isn't available inside the RGM app. Purchases and other features are available on the RGM Studio website.
        </p>
        <Button onClick={() => postToApp({ type: "open_external", path: pathname })} className="bg-purple-600 hover:bg-purple-700" data-testid="app-mode-open-external-btn">
          Open in browser
        </Button>
        <Button variant="outline" onClick={() => postToApp({ type: "close" })} className="ml-2" data-testid="app-mode-back-btn">
          Back to app
        </Button>
      </div>
    </div>
  );
}
